export default __webpack_public_path__ + "static/media/orange-background.22feaad4.png";